import { AssetType } from "../types";

export function getAssetId(data: any, assetType: AssetType) {
  if (assetType === "zap") {
    return data.zapId;
  }
  if (assetType === "table") {
    return data.tableId;
  }
  if (assetType === "interface") {
    return data.pageId;
  }
  if (assetType === "chatbot") {
    return data.chatbotId;
  }
  if (assetType === "agent") {
    return data.agentId;
  }
  return null;
}
